import Accounts32 from './accounts-32.svg'
import Adultfill16 from './adult-fill-16.svg'
import Adultfill24 from './adult-fill-24.svg'
import Adultfill32 from './adult-fill-32.svg'
import Adultfill64 from './adult-fill-64.svg'
import Adultstroke16 from './adult-stroke-16.svg'
import Adultstroke24 from './adult-stroke-24.svg'
import Adultstroke32 from './adult-stroke-32.svg'
import Adultstroke64 from './adult-stroke-64.svg'
import AlertChatBubble16 from './alert-chat-bubble-16.svg'
import AlertChatBubble24 from './alert-chat-bubble-24.svg'
import Arrow16left from './arrow-16-left.svg'
import Arrow16right from './arrow-16-right.svg'
import Arrow24left from './arrow-24-left.svg'
import Arrow24right from './arrow-24-right.svg'
import Arrow32left from './arrow-32-left.svg'
import Arrow32right from './arrow-32-right.svg'
import Basketfill16 from './basket-fill-16.svg'
import Basketfill24 from './basket-fill-24.svg'
import Basketfill32 from './basket-fill-32.svg'
import Basketstroke16 from './basket-stroke-16.svg'
import Basketstroke24 from './basket-stroke-24.svg'
import Basketstroke32 from './basket-stroke-32.svg'
import Bellfill16 from './bell-fill-16.svg'
import Bellfill24 from './bell-fill-24.svg'
import Bellfill32 from './bell-fill-32.svg'
import Bellstroke16 from './bell-stroke-16.svg'
import Bellstroke24 from './bell-stroke-24.svg'
import Bellstroke32 from './bell-stroke-32.svg'
import BikeStroke32 from './bike-stroke-32.svg'
import Bill16dollar from './bill-16-dollar.svg'
import Bill16euro from './bill-16-euro.svg'
import Bill24dollar from './bill-24-dollar.svg'
import Bill24euro from './bill-24-euro.svg'
import Bill32dollar from './bill-32-dollar.svg'
import Bill32euro from './bill-32-euro.svg'
import Bio32 from './bio-32.svg'
import Blender16fill from './blender-16-fill.svg'
import Blender16stroke from './blender-16-stroke.svg'
import Blender24fill from './blender-24-fill.svg'
import Blender24stroke from './blender-24-stroke.svg'
import Blender32fill from './blender-32-fill.svg'
import Blender32stroke from './blender-32-stroke.svg'
import Blender64fill from './blender-64-fill.svg'
import Blender64stroke from './blender-64-stroke.svg'
import Burger16 from './burger-16.svg'
import Burger24 from './burger-24.svg'
import Burger32 from './burger-32.svg'
import Calorie16 from './calorie-16.svg'
import Calorie24 from './calorie-24.svg'
import Calorie32 from './calorie-32.svg'
import Car16 from './car-16.svg'
import Car24 from './car-24.svg'
import Car32 from './car-32.svg'
import Cartcheck16 from './cart-check-16.svg'
import Cartcheck24 from './cart-check-24.svg'
import Cartcheck32 from './cart-check-32.svg'
import Cartdefault16 from './cart-default-16.svg'
import Cartdefault24 from './cart-default-24.svg'
import Cartdefault32 from './cart-default-32.svg'
import Cartfill16 from './cart-fill-16.svg'
import Cartfill24 from './cart-fill-24.svg'
import Cartfill32 from './cart-fill-32.svg'
import Cartplus16 from './cart-plus-16.svg'
import Cartplus24 from './cart-plus-24.svg'
import Cartplus32 from './cart-plus-32.svg'
import Cat16fill from './cat-16-fill.svg'
import Cat16stroke from './cat-16-stroke.svg'
import Cat24fill from './cat-24-fill.svg'
import Cat24stroke from './cat-24-stroke.svg'
import Cat32fill from './cat-32-fill.svg'
import Cat32stroke from './cat-32-stroke.svg'
import Cat64fill from './cat-64-fill.svg'
import Cat64stroke from './cat-64-stroke.svg'
import Chatbubble16 from './chat-bubble-16.svg'
import Chatbubble24 from './chat-bubble-24.svg'
import Chatbubble32 from './chat-bubble-32.svg'
import Chatbubble64 from './chat-bubble-64.svg'
import Checkmark16 from './checkmark-16.svg'
import Checkmark24 from './checkmark-24.svg'
import Checkmark32 from './checkmark-32.svg'
import Childfill16 from './child-fill-16.svg'
import Childfill24 from './child-fill-24.svg'
import Childfill32 from './child-fill-32.svg'
import Childfill64 from './child-fill-64.svg'
import Childstroke16 from './child-stroke-16.svg'
import Childstroke24 from './child-stroke-24.svg'
import Childstroke32 from './child-stroke-32.svg'
import Childstroke64 from './child-stroke-64.svg'
import Cloudycloudy16 from './cloudy-cloudy-16.svg'
import Cloudycloudy24 from './cloudy-cloudy-24.svg'
import Cloudycloudy32 from './cloudy-cloudy-32.svg'
import Cloudyrain16 from './cloudy-rain-16.svg'
import Cloudyrain24 from './cloudy-rain-24.svg'
import Cloudyrain32 from './cloudy-rain-32.svg'
import Cloudyshowers16 from './cloudy-showers-16.svg'
import Cloudyshowers24 from './cloudy-showers-24.svg'
import Cloudyshowers32 from './cloudy-showers-32.svg'
import Cloudythunder16 from './cloudy-thunder-16.svg'
import Cloudythunder24 from './cloudy-thunder-24.svg'
import Cloudythunder32 from './cloudy-thunder-32.svg'
import Copy16 from './copy-16.svg'
import Copy24 from './copy-24.svg'
import Copy32 from './copy-32.svg'
import Creditcardcheck16 from './credit-card-check-16.svg'
import Creditcardcheck24 from './credit-card-check-24.svg'
import Creditcardcheck32 from './credit-card-check-32.svg'
import Creditcardfill16 from './credit-card-fill-16.svg'
import Creditcardfill24 from './credit-card-fill-24.svg'
import Creditcardfill32 from './credit-card-fill-32.svg'
import Creditcardplus16 from './credit-card-plus-16.svg'
import Creditcardplus24 from './credit-card-plus-24.svg'
import Creditcardplus32 from './credit-card-plus-32.svg'
import Creditcardstroke16 from './credit-card-stroke-16.svg'
import Creditcardstroke24 from './credit-card-stroke-24.svg'
import Creditcardstroke32 from './credit-card-stroke-32.svg'
import Cross16 from './cross-16.svg'
import Cross24 from './cross-24.svg'
import Cross32 from './cross-32.svg'
import Dairyfree16fill from './dairy-free-16-fill.svg'
import Dairyfree16stroke from './dairy-free-16-stroke.svg'
import Dairyfree24fill from './dairy-free-24-fill.svg'
import Dairyfree24stroke from './dairy-free-24-stroke.svg'
import Dairyfree32fill from './dairy-free-32-fill.svg'
import Dairyfree32stroke from './dairy-free-32-stroke.svg'
import Dairyfree64fill from './dairy-free-64-fill.svg'
import Dairyfree64stroke from './dairy-free-64-stroke.svg'
import Deepfryer16fill from './deep-fryer-16-fill.svg'
import Deepfryer16stroke from './deep-fryer-16-stroke.svg'
import Deepfryer24fill from './deep-fryer-24-fill.svg'
import Deepfryer24stroke from './deep-fryer-24-stroke.svg'
import Deepfryer32fill from './deep-fryer-32-fill.svg'
import Deepfryer32stroke from './deep-fryer-32-stroke.svg'
import Deepfryer64fill from './deep-fryer-64-fill.svg'
import Deepfryer64stroke from './deep-fryer-64-stroke.svg'
import Delete16 from './delete-16.svg'
import Delete24 from './delete-24.svg'
import Delete32 from './delete-32.svg'
import Direction16down from './direction-16-down.svg'
import Direction16left from './direction-16-left.svg'
import Direction16right from './direction-16-right.svg'
import Direction16up from './direction-16-up.svg'
import Direction24down from './direction-24-down.svg'
import Direction24left from './direction-24-left.svg'
import Direction24right from './direction-24-right.svg'
import Direction24up from './direction-24-up.svg'
import Direction32down from './direction-32-down.svg'
import Direction32left from './direction-32-left.svg'
import Direction32right from './direction-32-right.svg'
import Direction32up from './direction-32-up.svg'
import Dislikes16 from './dislikes-16.svg'
import Dislikes24 from './dislikes-24.svg'
import Dislikes32 from './dislikes-32.svg'
import Dog16fill from './dog-16-fill.svg'
import Dog16stroke from './dog-16-stroke.svg'
import Dog24fill from './dog-24-fill.svg'
import Dog24stroke from './dog-24-stroke.svg'
import Dog32fill from './dog-32-fill.svg'
import Dog32stroke from './dog-32-stroke.svg'
import Dog64fill from './dog-64-fill.svg'
import Dog64stroke from './dog-64-stroke.svg'
import EmptyStroke16 from './empty-stroke-16.svg'
import EmptyStroke24 from './empty-stroke-24.svg'
import EmptyStroke32 from './empty-stroke-32.svg'
import Error16fill from './error-16-fill.svg'
import Error16stroke from './error-16-stroke.svg'
import Error24fill from './error-24-fill.svg'
import Error24stroke from './error-24-stroke.svg'
import Error32fill from './error-32-fill.svg'
import Error32stroke from './error-32-stroke.svg'
import Eyeclose16 from './eye-close-16.svg'
import Eyeclose24 from './eye-close-24.svg'
import Eyeclose32 from './eye-close-32.svg'
import Eyeopen16 from './eye-open-16.svg'
import Eyeopen24 from './eye-open-24.svg'
import Eyeopen32 from './eye-open-32.svg'
import Fidelityfill16 from './fidelity-fill-16.svg'
import Fidelityfill24 from './fidelity-fill-24.svg'
import Fidelityfill32 from './fidelity-fill-32.svg'
import Fidelitystroke16 from './fidelity-stroke-16.svg'
import Fidelitystroke24 from './fidelity-stroke-24.svg'
import Fidelitystroke32 from './fidelity-stroke-32.svg'
import Fresh32 from './fresh-32.svg'
import Frozen32 from './frozen-32.svg'
import Glutenfree16fill from './gluten-free-16-fill.svg'
import Glutenfree16stroke from './gluten-free-16-stroke.svg'
import Glutenfree24fill from './gluten-free-24-fill.svg'
import Glutenfree24stroke from './gluten-free-24-stroke.svg'
import Glutenfree32fill from './gluten-free-32-fill.svg'
import Glutenfree32stroke from './gluten-free-32-stroke.svg'
import Glutenfree64fill from './gluten-free-64-fill.svg'
import Glutenfree64stroke from './gluten-free-64-stroke.svg'
import Heartfill16 from './heart-fill-16.svg'
import Heartfill24 from './heart-fill-24.svg'
import Heartfill32 from './heart-fill-32.svg'
import Heartstroke16 from './heart-stroke-16.svg'
import Heartstroke24 from './heart-stroke-24.svg'
import Heartstroke32 from './heart-stroke-32.svg'
import Helpfill16 from './help-fill-16.svg'
import Helpfill24 from './help-fill-24.svg'
import Helpfill32 from './help-fill-32.svg'
import Helpstroke16 from './help-stroke-16.svg'
import Helpstroke24 from './help-stroke-24.svg'
import Helpstroke32 from './help-stroke-32.svg'
import Home16fill from './home-16-fill.svg'
import Home16stroke from './home-16-stroke.svg'
import Home24fill from './home-24-fill.svg'
import Home24stroke from './home-24-stroke.svg'
import Home32fill from './home-32-fill.svg'
import Home32stroke from './home-32-stroke.svg'
import Hotplate16fill from './hot-plate-16-fill.svg'
import Hotplate16stroke from './hot-plate-16-stroke.svg'
import Hotplate24fill from './hot-plate-24-fill.svg'
import Hotplate24stroke from './hot-plate-24-stroke.svg'
import Hotplate32fill from './hot-plate-32-fill.svg'
import Hotplate32stroke from './hot-plate-32-stroke.svg'
import Hotplate64fill from './hot-plate-64-fill.svg'
import Hotplate64stroke from './hot-plate-64-stroke.svg'
import Information16fill from './information-16-fill.svg'
import Information16stroke from './information-16-stroke.svg'
import Information24fill from './information-24-fill.svg'
import Information24stroke from './information-24-stroke.svg'
import Information32fill from './information-32-fill.svg'
import Information32stroke from './information-32-stroke.svg'
import InstagramVerified16 from './instagram-verified-16.svg'
import J64 from './j-64.svg'
import Jow64 from './jow-64.svg'
import Key16 from './key-16.svg'
import Key24 from './key-24.svg'
import Key32 from './key-32.svg'
import Key64 from './key-64.svg'
import Language16 from './language-16.svg'
import Language24 from './language-24.svg'
import Language32 from './language-32.svg'
import Less16 from './less-16.svg'
import Less24 from './less-24.svg'
import Less32 from './less-32.svg'
import List16 from './list-16.svg'
import List24 from './list-24.svg'
import List32 from './list-32.svg'
import LocationPinFill24 from './location-pin-fill-24.svg'
import Logout16 from './logout-16.svg'
import Logout24 from './logout-24.svg'
import Logout32 from './logout-32.svg'
import Magicstickfill24 from './magic-stick-fill-24.svg'
import Magicstickstroke24 from './magic-stick-stroke-24.svg'
import Mail16 from './mail-16.svg'
import Mail24 from './mail-24.svg'
import Mail32 from './mail-32.svg'
import Mail64 from './mail-64.svg'
import Map16 from './map-16.svg'
import Map24 from './map-24.svg'
import Map32 from './map-32.svg'
import Microwave16fill from './microwave-16-fill.svg'
import Microwave16stroke from './microwave-16-stroke.svg'
import Microwave24fill from './microwave-24-fill.svg'
import Microwave24stroke from './microwave-24-stroke.svg'
import Microwave32fill from './microwave-32-fill.svg'
import Microwave32stroke from './microwave-32-stroke.svg'
import Microwave64fill from './microwave-64-fill.svg'
import Microwave64stroke from './microwave-64-stroke.svg'
import Multicooker16fill from './multicooker-16-fill.svg'
import Multicooker16stroke from './multicooker-16-stroke.svg'
import Multicooker24fill from './multicooker-24-fill.svg'
import Multicooker24stroke from './multicooker-24-stroke.svg'
import Multicooker32fill from './multicooker-32-fill.svg'
import Multicooker32stroke from './multicooker-32-stroke.svg'
import Multicooker64fill from './multicooker-64-fill.svg'
import Multicooker64stroke from './multicooker-64-stroke.svg'
import MyRecipes16 from './my-recipes-16.svg'
import MyRecipes24 from './my-recipes-24.svg'
import MyRecipes32 from './my-recipes-32.svg'
import NavigationFill24 from './navigation-fill-24.svg'
import NavigationStroke24 from './navigation-stroke-24.svg'
import Organic16 from './organic-16.svg'
import Organic24 from './organic-24.svg'
import Organic32 from './organic-32.svg'
import Oven16fill from './oven-16-fill.svg'
import Oven16stroke from './oven-16-stroke.svg'
import Oven24fill from './oven-24-fill.svg'
import Oven24stroke from './oven-24-stroke.svg'
import Oven32fill from './oven-32-fill.svg'
import Oven32stroke from './oven-32-stroke.svg'
import Oven64fill from './oven-64-fill.svg'
import Oven64stroke from './oven-64-stroke.svg'
import PauseFill16 from './pause-fill-16.svg'
import PauseFill24 from './pause-fill-24.svg'
import PauseFill32 from './pause-fill-32.svg'
import PauseFill64 from './pause-fill-64.svg'
import PauseStroke16 from './pause-stroke-16.svg'
import PauseStroke24 from './pause-stroke-24.svg'
import PauseStroke32 from './pause-stroke-32.svg'
import PauseStroke64 from './pause-stroke-64.svg'
import Pedestrian16 from './pedestrian-16.svg'
import Pedestrian24 from './pedestrian-24.svg'
import Pedestrian32 from './pedestrian-32.svg'
import Pen16paper from './pen-16-paper.svg'
import Pen16pen from './pen-16-pen.svg'
import Pen24paper from './pen-24-paper.svg'
import Pen24pen from './pen-24-pen.svg'
import Pen32paper from './pen-32-paper.svg'
import Pen32pen from './pen-32-pen.svg'
import Pescetarian16fill from './pescetarian-16-fill.svg'
import Pescetarian16stroke from './pescetarian-16-stroke.svg'
import Pescetarian24fill from './pescetarian-24-fill.svg'
import Pescetarian24stroke from './pescetarian-24-stroke.svg'
import Pescetarian32fill from './pescetarian-32-fill.svg'
import Pescetarian32stroke from './pescetarian-32-stroke.svg'
import Pescetarian64fill from './pescetarian-64-fill.svg'
import Pescetarian64stroke from './pescetarian-64-stroke.svg'
import PiggyBankStroke32 from './piggy-bank-stroke-32.svg'
import Pin16 from './pin-16.svg'
import Pin24 from './pin-24.svg'
import Pin32 from './pin-32.svg'
import Plate16stroke from './plate-16-stroke.svg'
import Plate24stroke from './plate-24-stroke.svg'
import Plate32fill from './plate-32-fill.svg'
import Plate32stroke from './plate-32-stroke.svg'
import Play16stroke from './play-16-stroke.svg'
import Play24stroke from './play-24-stroke.svg'
import Play32fill from './play-32-fill.svg'
import Play32stroke from './play-32-stroke.svg'
import Play64stroke from './play-64-stroke.svg'
import Plus16 from './plus-16.svg'
import Plus24 from './plus-24.svg'
import Plus32 from './plus-32.svg'
import Porkfree16fill from './pork-free-16-fill.svg'
import Porkfree16stroke from './pork-free-16-stroke.svg'
import Porkfree24fill from './pork-free-24-fill.svg'
import Porkfree24stroke from './pork-free-24-stroke.svg'
import Porkfree32fill from './pork-free-32-fill.svg'
import Porkfree32stroke from './pork-free-32-stroke.svg'
import Porkfree64fill from './pork-free-64-fill.svg'
import Porkfree64stroke from './pork-free-64-stroke.svg'
import Preparation16 from './preparation-16.svg'
import Preparation24 from './preparation-24.svg'
import Preparation32 from './preparation-32.svg'
import Present16 from './present-16.svg'
import Present24 from './present-24.svg'
import Present32 from './present-32.svg'
import Present64 from './present-64.svg'
import Print16 from './print-16.svg'
import Print24 from './print-24.svg'
import Print32 from './print-32.svg'
import Profilefilllogged16 from './profile-fill-logged-16.svg'
import Profilefilllogged24 from './profile-fill-logged-24.svg'
import Profilefilllogged32 from './profile-fill-logged-32.svg'
import Profilefilllogin16 from './profile-fill-login-16.svg'
import Profilefilllogin24 from './profile-fill-login-24.svg'
import Profilefilllogin32 from './profile-fill-login-32.svg'
import Profilestrokelogged16 from './profile-stroke-logged-16.svg'
import Profilestrokelogged24 from './profile-stroke-logged-24.svg'
import Profilestrokelogged32 from './profile-stroke-logged-32.svg'
import Profilestrokelogin16 from './profile-stroke-login-16.svg'
import Profilestrokelogin24 from './profile-stroke-login-24.svg'
import Profilestrokelogin32 from './profile-stroke-login-32.svg'
import Referral16 from './referral-16.svg'
import Referral24 from './referral-24.svg'
import Referral32 from './referral-32.svg'
import Referral64 from './referral-64.svg'
import Refresh16 from './refresh-16.svg'
import Refresh24 from './refresh-24.svg'
import Refresh32 from './refresh-32.svg'
import ReturnArrow24 from './return-arrow-24.svg'
import Search16 from './search-16.svg'
import Search24 from './search-24.svg'
import Search32 from './search-32.svg'
import Selector16 from './selector-16.svg'
import Selector24 from './selector-24.svg'
import Selector32 from './selector-32.svg'
import Serving16 from './serving-16.svg'
import Serving24 from './serving-24.svg'
import Serving32 from './serving-32.svg'
import Settings16 from './settings-16.svg'
import Settings24 from './settings-24.svg'
import Settings32 from './settings-32.svg'
import Share16android from './share-16-android.svg'
import Share16ios from './share-16-ios.svg'
import Share24android from './share-24-android.svg'
import Share24ios from './share-24-ios.svg'
import Share32android from './share-32-android.svg'
import Share32ios from './share-32-ios.svg'
import Shelves16fill from './shelves-16-fill.svg'
import Shelves16stroke from './shelves-16-stroke.svg'
import Shelves24fill from './shelves-24-fill.svg'
import Shelves24stroke from './shelves-24-stroke.svg'
import Shelves32fill from './shelves-32-fill.svg'
import Shelves32stroke from './shelves-32-stroke.svg'
import Shelves64stroke from './shelves-64-stroke.svg'
import Shoppinglist16 from './shopping-list-16.svg'
import Shoppinglist24 from './shopping-list-24.svg'
import Shoppinglist32 from './shopping-list-32.svg'
import Slowcooker16fill from './slow-cooker-16-fill.svg'
import Slowcooker16stroke from './slow-cooker-16-stroke.svg'
import Slowcooker24fill from './slow-cooker-24-fill.svg'
import Slowcooker24stroke from './slow-cooker-24-stroke.svg'
import Slowcooker32fill from './slow-cooker-32-fill.svg'
import Slowcooker32stroke from './slow-cooker-32-stroke.svg'
import Slowcooker64fill from './slow-cooker-64-fill.svg'
import Slowcooker64stroke from './slow-cooker-64-stroke.svg'
import SmileDislike64 from './smile-dislike-64.svg'
import SmileLike64 from './smile-like-64.svg'
import SmileNeutral64 from './smile-neutral-64.svg'
import Soundoff16 from './sound-off-16.svg'
import Soundoff24 from './sound-off-24.svg'
import Soundoff32 from './sound-off-32.svg'
import Soundon16 from './sound-on-16.svg'
import Soundon24 from './sound-on-24.svg'
import Soundon32 from './sound-on-32.svg'
import StarFill32 from './star-fill-32.svg'
import StarStroke32 from './star-stroke-32.svg'
import Store16fill from './store-16-fill.svg'
import Store16stroke from './store-16-stroke.svg'
import Store24fill from './store-24-fill.svg'
import Store24stroke from './store-24-stroke.svg'
import Store32fill from './store-32-fill.svg'
import Store32stroke from './store-32-stroke.svg'
import Subtitles16 from './subtitles-16.svg'
import Subtitles24 from './subtitles-24.svg'
import Subtitles32 from './subtitles-32.svg'
import Switch16 from './switch-16.svg'
import Switch24 from './switch-24.svg'
import Switch32 from './switch-32.svg'
import Theme16dark from './theme-16-dark.svg'
import Theme16light from './theme-16-light.svg'
import Theme24dark from './theme-24-dark.svg'
import Theme24light from './theme-24-light.svg'
import Theme32dark from './theme-32-dark.svg'
import Theme32light from './theme-32-light.svg'
import ThumbsUpFill24 from './thumbs-up-fill-24.svg'
import ThumbsUpStroke24 from './thumbs-up-stroke-24.svg'
import Time16 from './time-16.svg'
import Time24 from './time-24.svg'
import Time32 from './time-32.svg'
import Time64 from './time-64.svg'
import TimerStroke32 from './timer-stroke-32.svg'
import Vegan16fill from './vegan-16-fill.svg'
import Vegan16stroke from './vegan-16-stroke.svg'
import Vegan24fill from './vegan-24-fill.svg'
import Vegan24stroke from './vegan-24-stroke.svg'
import Vegan32fill from './vegan-32-fill.svg'
import Vegan32stroke from './vegan-32-stroke.svg'
import Vegan64fill from './vegan-64-fill.svg'
import Vegan64stroke from './vegan-64-stroke.svg'
import Vegetarian16fill from './vegetarian-16-fill.svg'
import Vegetarian16stroke from './vegetarian-16-stroke.svg'
import Vegetarian24fill from './vegetarian-24-fill.svg'
import Vegetarian24stroke from './vegetarian-24-stroke.svg'
import Vegetarian32fill from './vegetarian-32-fill.svg'
import Vegetarian32stroke from './vegetarian-32-stroke.svg'
import Vegetarian64fill from './vegetarian-64-fill.svg'
import Vegetarian64stroke from './vegetarian-64-stroke.svg'
import Voucherfill16 from './voucher-fill-16.svg'
import Voucherfill24 from './voucher-fill-24.svg'
import Voucherfill32 from './voucher-fill-32.svg'
import Voucherstroke16 from './voucher-stroke-16.svg'
import Voucherstroke24 from './voucher-stroke-24.svg'
import Voucherstroke32 from './voucher-stroke-32.svg'
import WalletStroke32 from './wallet-stroke-32.svg'
import ZZ16 from './zz-16.svg'
import ZZZ24 from './zzz-24.svg'

const ICONS = {
  'accounts-32': Accounts32,
  'adult-fill-16': Adultfill16,
  'adult-fill-24': Adultfill24,
  'adult-fill-32': Adultfill32,
  'adult-fill-64': Adultfill64,
  'adult-stroke-16': Adultstroke16,
  'adult-stroke-24': Adultstroke24,
  'adult-stroke-32': Adultstroke32,
  'adult-stroke-64': Adultstroke64,
  'alert-chat-bubble-16': AlertChatBubble16,
  'alert-chat-bubble-24': AlertChatBubble24,
  'arrow-left-16': Arrow16left,
  'arrow-left-24': Arrow24left,
  'arrow-left-32': Arrow32left,
  'arrow-right-16': Arrow16right,
  'arrow-right-24': Arrow24right,
  'arrow-right-32': Arrow32right,
  'basket-fill-16': Basketfill16,
  'basket-fill-24': Basketfill24,
  'basket-fill-32': Basketfill32,
  'basket-stroke-16': Basketstroke16,
  'basket-stroke-24': Basketstroke24,
  'basket-stroke-32': Basketstroke32,
  'bell-fill-16': Bellfill16,
  'bell-fill-24': Bellfill24,
  'bell-fill-32': Bellfill32,
  'bell-stroke-16': Bellstroke16,
  'bell-stroke-24': Bellstroke24,
  'bell-stroke-32': Bellstroke32,
  'bike-stroke-32': BikeStroke32,
  'bill-dollar-16': Bill16dollar,
  'bill-dollar-24': Bill24dollar,
  'bill-dollar-32': Bill32dollar,
  'bill-euro-16': Bill16euro,
  'bill-euro-24': Bill24euro,
  'bill-euro-32': Bill32euro,
  'bio-32': Bio32,
  'blender-fill-16': Blender16fill,
  'blender-fill-24': Blender24fill,
  'blender-fill-32': Blender32fill,
  'blender-fill-64': Blender64fill,
  'blender-stroke-16': Blender16stroke,
  'blender-stroke-24': Blender24stroke,
  'blender-stroke-32': Blender32stroke,
  'blender-stroke-64': Blender64stroke,
  'burger-16': Burger16,
  'burger-24': Burger24,
  'burger-32': Burger32,
  'calorie-16': Calorie16,
  'calorie-24': Calorie24,
  'calorie-32': Calorie32,
  'car-16': Car16,
  'car-24': Car24,
  'car-32': Car32,
  'cart-check-16': Cartcheck16,
  'cart-check-24': Cartcheck24,
  'cart-check-32': Cartcheck32,
  'cart-default-16': Cartdefault16,
  'cart-default-24': Cartdefault24,
  'cart-default-32': Cartdefault32,
  'cart-fill-16': Cartfill16,
  'cart-fill-24': Cartfill24,
  'cart-fill-32': Cartfill32,
  'cart-plus-16': Cartplus16,
  'cart-plus-24': Cartplus24,
  'cart-plus-32': Cartplus32,
  'cat-fill-16': Cat16fill,
  'cat-fill-24': Cat24fill,
  'cat-fill-32': Cat32fill,
  'cat-fill-64': Cat64fill,
  'cat-stroke-16': Cat16stroke,
  'cat-stroke-24': Cat24stroke,
  'cat-stroke-32': Cat32stroke,
  'cat-stroke-64': Cat64stroke,
  'chat-bubble-16': Chatbubble16,
  'chat-bubble-24': Chatbubble24,
  'chat-bubble-32': Chatbubble32,
  'chat-bubble-64': Chatbubble64,
  'checkmark-16': Checkmark16,
  'checkmark-24': Checkmark24,
  'checkmark-32': Checkmark32,
  'child-fill-16': Childfill16,
  'child-fill-24': Childfill24,
  'child-fill-32': Childfill32,
  'child-fill-64': Childfill64,
  'child-stroke-16': Childstroke16,
  'child-stroke-24': Childstroke24,
  'child-stroke-32': Childstroke32,
  'child-stroke-64': Childstroke64,
  'cloudy-cloudy-16': Cloudycloudy16,
  'cloudy-cloudy-24': Cloudycloudy24,
  'cloudy-cloudy-32': Cloudycloudy32,
  'cloudy-rain-16': Cloudyrain16,
  'cloudy-rain-24': Cloudyrain24,
  'cloudy-rain-32': Cloudyrain32,
  'cloudy-showers-16': Cloudyshowers16,
  'cloudy-showers-24': Cloudyshowers24,
  'cloudy-showers-32': Cloudyshowers32,
  'cloudy-thunder-16': Cloudythunder16,
  'cloudy-thunder-24': Cloudythunder24,
  'cloudy-thunder-32': Cloudythunder32,
  'copy-16': Copy16,
  'copy-24': Copy24,
  'copy-32': Copy32,
  'credit-card-check-16': Creditcardcheck16,
  'credit-card-check-24': Creditcardcheck24,
  'credit-card-check-32': Creditcardcheck32,
  'credit-card-fill-16': Creditcardfill16,
  'credit-card-fill-24': Creditcardfill24,
  'credit-card-fill-32': Creditcardfill32,
  'credit-card-plus-16': Creditcardplus16,
  'credit-card-plus-24': Creditcardplus24,
  'credit-card-plus-32': Creditcardplus32,
  'credit-card-stroke-16': Creditcardstroke16,
  'credit-card-stroke-24': Creditcardstroke24,
  'credit-card-stroke-32': Creditcardstroke32,
  'cross-16': Cross16,
  'cross-24': Cross24,
  'cross-32': Cross32,
  'dairy-free-fill-16': Dairyfree16fill,
  'dairy-free-fill-24': Dairyfree24fill,
  'dairy-free-fill-32': Dairyfree32fill,
  'dairy-free-fill-64': Dairyfree64fill,
  'dairy-free-stroke-16': Dairyfree16stroke,
  'dairy-free-stroke-24': Dairyfree24stroke,
  'dairy-free-stroke-32': Dairyfree32stroke,
  'dairy-free-stroke-64': Dairyfree64stroke,
  'deep-fryer-fill-16': Deepfryer16fill,
  'deep-fryer-fill-24': Deepfryer24fill,
  'deep-fryer-fill-32': Deepfryer32fill,
  'deep-fryer-fill-64': Deepfryer64fill,
  'deep-fryer-stroke-16': Deepfryer16stroke,
  'deep-fryer-stroke-24': Deepfryer24stroke,
  'deep-fryer-stroke-32': Deepfryer32stroke,
  'deep-fryer-stroke-64': Deepfryer64stroke,
  'delete-16': Delete16,
  'delete-24': Delete24,
  'delete-32': Delete32,
  'direction-down-16': Direction16down,
  'direction-down-24': Direction24down,
  'direction-down-32': Direction32down,
  'direction-left-16': Direction16left,
  'direction-left-24': Direction24left,
  'direction-left-32': Direction32left,
  'direction-right-16': Direction16right,
  'direction-right-24': Direction24right,
  'direction-right-32': Direction32right,
  'direction-up-16': Direction16up,
  'direction-up-24': Direction24up,
  'direction-up-32': Direction32up,
  'dislikes-16': Dislikes16,
  'dislikes-24': Dislikes24,
  'dislikes-32': Dislikes32,
  'dog-fill-16': Dog16fill,
  'dog-fill-24': Dog24fill,
  'dog-fill-32': Dog32fill,
  'dog-fill-64': Dog64fill,
  'dog-stroke-16': Dog16stroke,
  'dog-stroke-24': Dog24stroke,
  'dog-stroke-32': Dog32stroke,
  'dog-stroke-64': Dog64stroke,
  'empty-stroke-16': EmptyStroke16,
  'empty-stroke-24': EmptyStroke24,
  'empty-stroke-32': EmptyStroke32,
  'error-fill-16': Error16fill,
  'error-fill-24': Error24fill,
  'error-fill-32': Error32fill,
  'error-stroke-16': Error16stroke,
  'error-stroke-24': Error24stroke,
  'error-stroke-32': Error32stroke,
  'eye-close-16': Eyeclose16,
  'eye-close-24': Eyeclose24,
  'eye-close-32': Eyeclose32,
  'eye-open-16': Eyeopen16,
  'eye-open-24': Eyeopen24,
  'eye-open-32': Eyeopen32,
  'fidelity-fill-16': Fidelityfill16,
  'fidelity-fill-24': Fidelityfill24,
  'fidelity-fill-32': Fidelityfill32,
  'fidelity-stroke-16': Fidelitystroke16,
  'fidelity-stroke-24': Fidelitystroke24,
  'fidelity-stroke-32': Fidelitystroke32,
  'fresh-32': Fresh32,
  'frozen-32': Frozen32,
  'gluten-free-fill-16': Glutenfree16fill,
  'gluten-free-fill-24': Glutenfree24fill,
  'gluten-free-fill-32': Glutenfree32fill,
  'gluten-free-fill-64': Glutenfree64fill,
  'gluten-free-stroke-16': Glutenfree16stroke,
  'gluten-free-stroke-24': Glutenfree24stroke,
  'gluten-free-stroke-32': Glutenfree32stroke,
  'gluten-free-stroke-64': Glutenfree64stroke,
  'heart-fill-16': Heartfill16,
  'heart-fill-24': Heartfill24,
  'heart-fill-32': Heartfill32,
  'heart-stroke-16': Heartstroke16,
  'heart-stroke-24': Heartstroke24,
  'heart-stroke-32': Heartstroke32,
  'help-fill-16': Helpfill16,
  'help-fill-24': Helpfill24,
  'help-fill-32': Helpfill32,
  'help-stroke-16': Helpstroke16,
  'help-stroke-24': Helpstroke24,
  'help-stroke-32': Helpstroke32,
  'home-fill-16': Home16fill,
  'home-fill-24': Home24fill,
  'home-fill-32': Home32fill,
  'home-stroke-16': Home16stroke,
  'home-stroke-24': Home24stroke,
  'home-stroke-32': Home32stroke,
  'hot-plate-fill-16': Hotplate16fill,
  'hot-plate-fill-24': Hotplate24fill,
  'hot-plate-fill-32': Hotplate32fill,
  'hot-plate-fill-64': Hotplate64fill,
  'hot-plate-stroke-16': Hotplate16stroke,
  'hot-plate-stroke-24': Hotplate24stroke,
  'hot-plate-stroke-32': Hotplate32stroke,
  'hot-plate-stroke-64': Hotplate64stroke,
  'information-fill-16': Information16fill,
  'information-fill-24': Information24fill,
  'information-fill-32': Information32fill,
  'information-stroke-16': Information16stroke,
  'information-stroke-24': Information24stroke,
  'information-stroke-32': Information32stroke,
  'instagram-verified-16': InstagramVerified16,
  'j-64': J64,
  'jow-64': Jow64,
  'key-16': Key16,
  'key-24': Key24,
  'key-32': Key32,
  'key-64': Key64,
  'language-16': Language16,
  'language-24': Language24,
  'language-32': Language32,
  'less-16': Less16,
  'less-24': Less24,
  'less-32': Less32,
  'list-16': List16,
  'list-24': List24,
  'list-32': List32,
  'location-pin-fill-24': LocationPinFill24,
  'logout-16': Logout16,
  'logout-24': Logout24,
  'logout-32': Logout32,
  'magic-stick-fill-24': Magicstickfill24,
  'magic-stick-stroke-24': Magicstickstroke24,
  'mail-16': Mail16,
  'mail-24': Mail24,
  'mail-32': Mail32,
  'mail-64': Mail64,
  'map-16': Map16,
  'map-24': Map24,
  'map-32': Map32,
  'microwave-fill-16': Microwave16fill,
  'microwave-fill-24': Microwave24fill,
  'microwave-fill-32': Microwave32fill,
  'microwave-fill-64': Microwave64fill,
  'microwave-stroke-16': Microwave16stroke,
  'microwave-stroke-24': Microwave24stroke,
  'microwave-stroke-32': Microwave32stroke,
  'microwave-stroke-64': Microwave64stroke,
  'multicooker-fill-16': Multicooker16fill,
  'multicooker-fill-24': Multicooker24fill,
  'multicooker-fill-32': Multicooker32fill,
  'multicooker-fill-64': Multicooker64fill,
  'multicooker-stroke-16': Multicooker16stroke,
  'multicooker-stroke-24': Multicooker24stroke,
  'multicooker-stroke-32': Multicooker32stroke,
  'multicooker-stroke-64': Multicooker64stroke,
  'my-recipes-16': MyRecipes16,
  'my-recipes-24': MyRecipes24,
  'my-recipes-32': MyRecipes32,
  'navigation-fill-24': NavigationFill24,
  'navigation-stroke-24': NavigationStroke24,
  'organic-16': Organic16,
  'organic-24': Organic24,
  'organic-32': Organic32,
  'oven-fill-16': Oven16fill,
  'oven-fill-24': Oven24fill,
  'oven-fill-32': Oven32fill,
  'oven-fill-64': Oven64fill,
  'oven-stroke-16': Oven16stroke,
  'oven-stroke-24': Oven24stroke,
  'oven-stroke-32': Oven32stroke,
  'oven-stroke-64': Oven64stroke,
  'pause-fill-16': PauseFill16,
  'pause-fill-24': PauseFill24,
  'pause-fill-32': PauseFill32,
  'pause-fill-64': PauseFill64,
  'pause-stroke-16': PauseStroke16,
  'pause-stroke-24': PauseStroke24,
  'pause-stroke-32': PauseStroke32,
  'pause-stroke-64': PauseStroke64,
  'pedestrian-16': Pedestrian16,
  'pedestrian-24': Pedestrian24,
  'pedestrian-32': Pedestrian32,
  'pen-paper-16': Pen16paper,
  'pen-paper-24': Pen24paper,
  'pen-paper-32': Pen32paper,
  'pen-pen-16': Pen16pen,
  'pen-pen-24': Pen24pen,
  'pen-pen-32': Pen32pen,
  'pescetarian-fill-16': Pescetarian16fill,
  'pescetarian-fill-24': Pescetarian24fill,
  'pescetarian-fill-32': Pescetarian32fill,
  'pescetarian-fill-64': Pescetarian64fill,
  'pescetarian-stroke-16': Pescetarian16stroke,
  'pescetarian-stroke-24': Pescetarian24stroke,
  'pescetarian-stroke-32': Pescetarian32stroke,
  'pescetarian-stroke-64': Pescetarian64stroke,
  'piggy-bank-stroke-32': PiggyBankStroke32,
  'pin-16': Pin16,
  'pin-24': Pin24,
  'pin-32': Pin32,
  'plate-fill-32': Plate32fill,
  'plate-stroke-16': Plate16stroke,
  'plate-stroke-24': Plate24stroke,
  'plate-stroke-32': Plate32stroke,
  'play-fill-32': Play32fill,
  'play-stroke-16': Play16stroke,
  'play-stroke-24': Play24stroke,
  'play-stroke-32': Play32stroke,
  'play-stroke-64': Play64stroke,
  'plus-16': Plus16,
  'plus-24': Plus24,
  'plus-32': Plus32,
  'pork-free-fill-16': Porkfree16fill,
  'pork-free-fill-24': Porkfree24fill,
  'pork-free-fill-32': Porkfree32fill,
  'pork-free-fill-64': Porkfree64fill,
  'pork-free-stroke-16': Porkfree16stroke,
  'pork-free-stroke-24': Porkfree24stroke,
  'pork-free-stroke-32': Porkfree32stroke,
  'pork-free-stroke-64': Porkfree64stroke,
  'preparation-16': Preparation16,
  'preparation-24': Preparation24,
  'preparation-32': Preparation32,
  'present-16': Present16,
  'present-24': Present24,
  'present-32': Present32,
  'present-64': Present64,
  'print-16': Print16,
  'print-24': Print24,
  'print-32': Print32,
  'profile-fill-logged-16': Profilefilllogged16,
  'profile-fill-logged-24': Profilefilllogged24,
  'profile-fill-logged-32': Profilefilllogged32,
  'profile-fill-login-16': Profilefilllogin16,
  'profile-fill-login-24': Profilefilllogin24,
  'profile-fill-login-32': Profilefilllogin32,
  'profile-stroke-logged-16': Profilestrokelogged16,
  'profile-stroke-logged-24': Profilestrokelogged24,
  'profile-stroke-logged-32': Profilestrokelogged32,
  'profile-stroke-login-16': Profilestrokelogin16,
  'profile-stroke-login-24': Profilestrokelogin24,
  'profile-stroke-login-32': Profilestrokelogin32,
  'referral-16': Referral16,
  'referral-24': Referral24,
  'referral-32': Referral32,
  'referral-64': Referral64,
  'refresh-16': Refresh16,
  'refresh-24': Refresh24,
  'refresh-32': Refresh32,
  'return-arrow-24': ReturnArrow24,
  'search-16': Search16,
  'search-24': Search24,
  'search-32': Search32,
  'selector-16': Selector16,
  'selector-24': Selector24,
  'selector-32': Selector32,
  'serving-16': Serving16,
  'serving-24': Serving24,
  'serving-32': Serving32,
  'settings-16': Settings16,
  'settings-24': Settings24,
  'settings-32': Settings32,
  'share-android-16': Share16android,
  'share-android-24': Share24android,
  'share-android-32': Share32android,
  'share-ios-16': Share16ios,
  'share-ios-24': Share24ios,
  'share-ios-32': Share32ios,
  'shelves-fill-16': Shelves16fill,
  'shelves-fill-24': Shelves24fill,
  'shelves-fill-32': Shelves32fill,
  'shelves-stroke-16': Shelves16stroke,
  'shelves-stroke-24': Shelves24stroke,
  'shelves-stroke-32': Shelves32stroke,
  'shelves-stroke-64': Shelves64stroke,
  'shopping-list-16': Shoppinglist16,
  'shopping-list-24': Shoppinglist24,
  'shopping-list-32': Shoppinglist32,
  'slow-cooker-fill-16': Slowcooker16fill,
  'slow-cooker-fill-24': Slowcooker24fill,
  'slow-cooker-fill-32': Slowcooker32fill,
  'slow-cooker-fill-64': Slowcooker64fill,
  'slow-cooker-stroke-16': Slowcooker16stroke,
  'slow-cooker-stroke-24': Slowcooker24stroke,
  'slow-cooker-stroke-32': Slowcooker32stroke,
  'slow-cooker-stroke-64': Slowcooker64stroke,
  'smile-dislike-64': SmileDislike64,
  'smile-like-64': SmileLike64,
  'smile-neutral-64': SmileNeutral64,
  'sound-off-16': Soundoff16,
  'sound-off-24': Soundoff24,
  'sound-off-32': Soundoff32,
  'sound-on-16': Soundon16,
  'sound-on-24': Soundon24,
  'sound-on-32': Soundon32,
  'star-fill-32': StarFill32,
  'star-stroke-32': StarStroke32,
  'store-fill-16': Store16fill,
  'store-fill-24': Store24fill,
  'store-fill-32': Store32fill,
  'store-stroke-16': Store16stroke,
  'store-stroke-24': Store24stroke,
  'store-stroke-32': Store32stroke,
  'subtitles-16': Subtitles16,
  'subtitles-24': Subtitles24,
  'subtitles-32': Subtitles32,
  'switch-16': Switch16,
  'switch-24': Switch24,
  'switch-32': Switch32,
  'theme-dark-16': Theme16dark,
  'theme-dark-24': Theme24dark,
  'theme-dark-32': Theme32dark,
  'theme-light-16': Theme16light,
  'theme-light-24': Theme24light,
  'theme-light-32': Theme32light,
  'thumbs-up-fill-24': ThumbsUpFill24,
  'thumbs-up-stroke-24': ThumbsUpStroke24,
  'time-16': Time16,
  'time-24': Time24,
  'time-32': Time32,
  'time-64': Time64,
  'timer-stroke-32': TimerStroke32,
  'vegan-fill-16': Vegan16fill,
  'vegan-fill-24': Vegan24fill,
  'vegan-fill-32': Vegan32fill,
  'vegan-fill-64': Vegan64fill,
  'vegan-stroke-16': Vegan16stroke,
  'vegan-stroke-24': Vegan24stroke,
  'vegan-stroke-32': Vegan32stroke,
  'vegan-stroke-64': Vegan64stroke,
  'vegetarian-fill-16': Vegetarian16fill,
  'vegetarian-fill-24': Vegetarian24fill,
  'vegetarian-fill-32': Vegetarian32fill,
  'vegetarian-fill-64': Vegetarian64fill,
  'vegetarian-stroke-16': Vegetarian16stroke,
  'vegetarian-stroke-24': Vegetarian24stroke,
  'vegetarian-stroke-32': Vegetarian32stroke,
  'vegetarian-stroke-64': Vegetarian64stroke,
  'voucher-fill-16': Voucherfill16,
  'voucher-fill-24': Voucherfill24,
  'voucher-fill-32': Voucherfill32,
  'voucher-stroke-16': Voucherstroke16,
  'voucher-stroke-24': Voucherstroke24,
  'voucher-stroke-32': Voucherstroke32,
  'wallet-stroke-32': WalletStroke32,
  'zz-16': ZZ16,
  'zzz-24': ZZZ24,
}

export default ICONS
